module.exports = __webpack_public_path__ + "img/jin12.beab8cdb.png";